import { Chip } from '@mui/material';

function NicheBadge({ children, tone = 'neutral' }) {
  return (
    <Chip
      label={children}
      size="small"
      sx={{
        bgcolor: '#4E28B5',
        color: 'white',
        fontWeight: 700,
        '& .MuiChip-icon': { color: 'success.main' },
      }}
      variant={tone === 'neutral' ? 'outlined' : 'filled'}
    />
  );
}

export default NicheBadge;
